import { get } from "lodash";
import moment from "moment";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCheckCircle,
} from "react-icons/md";
import Card from "shared/components/Card";
import { CONTACT_POINT_SYSTEM, DATE_FORMAT } from "utils/constants";
import ActionButtons from "../Components/ActionButtons";
import InfoBox from "../Components/InfoBox";

const View = ({ translate, project, generalCost, onBack, next, loading, }) => {
  const quoteNumber = get(
    project,
    `fields.quoteNumber.${get(generalCost, "insurancePlan.id")}`,
  );
  const clientEmail = get(project, "contact.telecoms", []).find(
    ({ system }) => system === CONTACT_POINT_SYSTEM.EMAIL,
  )?.value;
  const clientPhone = get(project, "contact.telecoms", []).find(
    ({ system }) => system === CONTACT_POINT_SYSTEM.PHONE,
  )?.value;
  const totalPrice = get(
    project,
    `fields.upsells.${get(generalCost, "insurancePlan.id")}`,
    [],
  ).reduce((acc, { cost }) => acc + cost, get(generalCost, "cost", 0));
  return (
    <div className="template-product-filters--container">
      <div className="template-product-filters--wrapper">
        <Card title={translate.TITLE} subtitle={translate.SUBTITLE}>
          <div className="m-bottom-24">
            <InfoBox
              variant="success"
              icon={<MdCheckCircle size={24} />}
              content={
                <div>
                  <p className="infoBox--content__title">
                    {translate.SUCCESS_TITLE}
                  </p>
                  <p className="">{translate.SUCCESS_DESCRIPTION}</p>
                </div>
              }
            />
          </div>

          <div className="card__custom card--full">
            <div className="card__custom--head m-bottom-24">
              <div>
                <h3 className="card__custom--head--title">DEVIS</h3>
                <p className="text-sm text--secondary">
                  {translate.QUOTE_NUMBER_LABEL} {quoteNumber}
                </p>
              </div>
              <div className="d-flex gap-8 flex--column align--end">
                <span className="text-sm text--secondary">
                  {translate.VALIDITY_LABEL}
                </span>
                <span className="text-md">
                  Valable jusqu'au {moment().add(30, "d").format(DATE_FORMAT)}
                </span>
              </div>
            </div>

            <div className="m-bottom-24">
              <h4 className="text-sm text--secondary m-bottom-5">
                {translate.CLIENT_LABEL}
              </h4>
              <p className="text-md">
                {get(project, "contact.user.firstname")}{" "}
                {get(project, "contact.user.lastname")}
                {clientEmail}
                {clientPhone}
              </p>
            </div>

            <div className="m-bottom-24">
              <div className="d-flex justify--between m-bottom-8 text-sm text--secondary">
                <span>{translate.PRODUCT_LABEL}</span>
                <div className="d-flex gap-16">
                  <span>{translate.UNIT_PRICE_LABEL}</span>
                  <span>{translate.QUANTITY_LABEL}</span>
                  <span>{translate.TOTAL_LABEL}</span>
                </div>
              </div>
              <div className="m-bottom-16">
                <div className="d-flex justify--between m-bottom-12">
                  <div>
                    <p className="text-md m-bottom-5">
                      {get(generalCost, "insurancePlan.name")}
                    </p>
                    <p className="text-sm text--secondary">
                      {get(generalCost, "insurancePlan.description")}
                    </p>
                  </div>
                  <div className="d-flex gap-16">
                    <span className="text-md">
                      {get(generalCost, "cost").toFixed(2)} €
                    </span>
                    <span className="text-md">1</span>
                    <span className="text-md">
                      {get(generalCost, "cost").toFixed(2)} €
                    </span>
                  </div>
                </div>
                {get(
                  project,
                  `fields.upsells.${get(generalCost, "insurancePlan.id")}`,
                  [],
                ).map((line) => (
                  <div
                    key={line.id}
                    className="d-flex justify--between m-bottom-12"
                  >
                    <div>
                      <p className="text-md m-bottom-5">
                        {get(line, "insurancePlan.name")}
                      </p>
                      <p className="text-sm text--secondary">
                        {get(line, "insurancePlan.description")}
                      </p>
                    </div>
                    <div className="d-flex gap-16">
                      <span className="text-md">
                        {get(line, "cost").toFixed(2)} €
                      </span>
                      <span className="text-md">1</span>
                      <span className="text-md">
                        {get(line, "cost").toFixed(2)} €
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex justify--between text-md m-bottom-8">
                <span className="text--secondary">
                  {translate.SUBTOTAL_LABEL}
                </span>
                <span>{totalPrice.toFixed(2)} €</span>
              </div>
              <div className="d-flex justify--between text-md">
                <strong>{translate.TOTAL_LABEL}</strong>
                <strong className="text--primary">
                  {totalPrice.toFixed(2)} €
                </strong>
              </div>
            </div>
          </div>
          <ActionButtons
            onBack={onBack}
            onSubmit={next}
            loading={loading}
            translation={{
              NEXT: "Continuer vers la souscription",
              PREVIOUS: "Retour",
            }}
            icons={{
              next: <MdArrowForwardIos size={16} />,
              previous: <MdArrowBackIos size={16} />,
            }}
          />
        </Card>
      </div>
    </div>
  );
};

export default View;
